import { render } from "./ProductDetailPage.vue?vue&type=template&id=0ac5ff21&scoped=true"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js"

import "./ProductDetailPage.vue?vue&type=style&index=0&id=0ac5ff21&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac5ff21"]])

export default __exports__